export const StateNames = {
  ADD_REPORTING_PROFILES: 'reportingprofiles.add',
  EDIT_REPORTING_PROFILES: 'reportingprofiles.detail',
  REPORTING_PROFILES_DETAIL: 'reportingprofiles.detailwithallservices',
  EMPTY_STATE: 'empty-state',
  ADD_CATEGORIES_DETAIL: 'categories.add',
  EDIT_CATEGORIES_DETAIL: 'categories.detail',
  CATEGORIES_DATAVIEWS: 'categories.dataviews',
  CATEGORIES_METRIC: 'categories.metric',
  MANAGE_SERVICES: 'service.manage',
  MANAGE_SERVICES_CONNECTIONS: 'service.manage.showconnection',
  MANAGE_SERVICES_OPEN: 'service.manage.open',
  SERVICE_MAPPINGS: 'service.mappings',
  SERVICE_MAPPINGS_ERROR: 'service.mappings.error',
  REPORTSTUDIO_VIEW: 'exportbuilder-builder',
  FAV_REPORTSTUDIO_VIEW: 'fav-exportbuilder-builder',
  BILLING: 'billing',
  BILLING_ADDRESS: 'billing.address',
  BILLING_CREDITCARD: 'billing.creditcard',
  MANAGE_LEADS: 'manageleads',
  DASHBOARD_VIEW: 'dash',
  FAV_DASHBOARD_VIEW: 'fav-dash',
  NAMINGCONVENTIONS: 'namingconventions',
  GOALS: 'goals',
  QUICKREPORT: 'quickreport',
  IMPORTWIZARD_DETAIL: 'importwizard.detail',
  ADD_IMPORTWIZARD: 'importwizard.add',
  CLONE_IMPORTWIZARD: 'importwizard.clone',
  SUB_IMPORTWIZARD: 'importwizard.sub',
  LEADS: 'leads',
  INTEGRATIONS: 'integrations',
  INTEGRATIONS_MAPPINGS: 'integrations.mappings',
  INTEGRATIONS_CONFIGURE: 'integrations.configure',
  INTEGRATIONS_FILE_INTEGRATION: 'integrations.fileIntegration',
  INTEGRATIONS_UPDATE_FILE_INTEGRATION: 'integrations.updateFileIntegration',
  INTEGRATIONS_SALESFORCE_INTEGRATION: 'integrations.salesforceIntegration',
  INTEGRATIONS_UPDATE_SALESFORCE_INTEGRATION: 'integrations.updateSalesforceIntegration',
  INTEGRATIONS_WEBHOOK: 'integrations.webhook',
  INTEGRATIONS_ACTIVITY_LOG: 'integrations.activityLog',
  INTEGRATIONS_ACTIVITY_RESULT_VIEW: 'integrations.activityResultView',
};

export const RouteNames = {
  ADD_REPORTING_PROFILES: 'reportingprofilesform:new',
  EDIT_REPORTING_PROFILES: 'reportingprofilesform',
  REPORTING_PROFILES_DETAIL: 'reportingprofiledetail',
  ADD_CATEGORIES_DETAILS: 'categoriesForm:new',
  EDIT_CATEGORIES_DETAIL: 'categoriesForm',
  CATEGORIES_DATAVIEWS: 'categoriesdataviews',
  CATEGORIES_METRIC: 'categoriesmetric',
  MANAGE_SERVICES: 'servicemanage',
  MANAGE_SERVICES_CONNECTIONS: 'servicemanage:showconnection',
  SERVICE_MANAGE_OPEN: 'servicemanage:open',
  SERVICE_MAPPINGS: 'servicemappings',
  REPORTSTUDIO_VIEW: 'reportstudioview',
  DASHBOARD_VIEW: 'dashboardview',
  MANAGE_LEADS: 'manageleads',
  NAMINGCONVENTIONS: 'namingconventions',
  BILLING: 'billing',
  BILLING_ADDRESS: 'billingaddress',
  BILLING_CREDITCARD: 'billingcreditcard',
  GOALS: 'goals',
  QUICKREPORT: 'quickreport',
  EDIT_IMPORTWIZARD: 'importwizardform',
  ADD_IMPORTWIZARD: 'importwizardform:new',
  CLONE_IMPORTWIZARD: 'importwizardform:clone',
  SUB_IMPORTWIZARD: 'importwizardform:sub',
  LEADS: 'leads',
  INTEGRATIONS: 'integrations',
  INTEGRATIONS_MAPPINGS: 'integrations:mappings',
  INTEGRATIONS_CONFIGURE: 'integrations:configure',
  INTEGRATIONS_FILE_INTEGRATION: 'integrations:fileintegration',
  INTEGRATIONS_UPDATE_FILE_INTEGRATION: 'integrations:updatefileintegration',
  INTEGRATIONS_SALESFORCE_INTEGRATION: 'integrations:salesforceintegration',
  INTEGRATIONS_UPDATE_SALESFORCE_INTEGRATION: 'integrations:updatesalesforceintegration',
  INTEGRATIONS_WEBHOOK: 'integrations:webhook',
  INTEGRATIONS_ACTIVITY_LOG: 'integrations:activitylog',
  INTEGRATIONS_ACTIVITY_RESULT_VIEW: 'integrations:activityresultview',
};

export const StateRoutes = {
  [StateNames.ADD_REPORTING_PROFILES]: RouteNames.ADD_REPORTING_PROFILES,
  [StateNames.EDIT_REPORTING_PROFILES]: RouteNames.EDIT_REPORTING_PROFILES,
  [StateNames.REPORTING_PROFILES_DETAIL]: RouteNames.REPORTING_PROFILES_DETAIL,
  [StateNames.ADD_CATEGORIES_DETAIL]: RouteNames.ADD_CATEGORIES_DETAILS,
  [StateNames.EDIT_CATEGORIES_DETAIL]: RouteNames.EDIT_CATEGORIES_DETAIL,
  [StateNames.CATEGORIES_DATAVIEWS]: RouteNames.CATEGORIES_DATAVIEWS,
  [StateNames.CATEGORIES_METRIC]: RouteNames.CATEGORIES_METRIC,
  [StateNames.MANAGE_SERVICES]: RouteNames.MANAGE_SERVICES,
  [StateNames.MANAGE_SERVICES_CONNECTIONS]: RouteNames.MANAGE_SERVICES_CONNECTIONS,
  [StateNames.MANAGE_SERVICES_OPEN]: RouteNames.SERVICE_MANAGE_OPEN,
  [StateNames.SERVICE_MAPPINGS]: RouteNames.SERVICE_MAPPINGS,
  [StateNames.REPORTSTUDIO_VIEW]: RouteNames.REPORTSTUDIO_VIEW,
  [StateNames.DASHBOARD_VIEW]: RouteNames.DASHBOARD_VIEW,
  [StateNames.MANAGE_LEADS]: RouteNames.MANAGE_LEADS,
  [StateNames.NAMINGCONVENTIONS]: RouteNames.NAMINGCONVENTIONS,
  [StateNames.BILLING]: RouteNames.BILLING,
  [StateNames.BILLING_ADDRESS]: RouteNames.BILLING_ADDRESS,
  [StateNames.BILLING_CREDITCARD]: RouteNames.BILLING_CREDITCARD,
  [StateNames.GOALS]: RouteNames.GOALS,
  [StateNames.QUICKREPORT]: RouteNames.QUICKREPORT,
  [StateNames.IMPORTWIZARD_DETAIL]: RouteNames.EDIT_IMPORTWIZARD,
  [StateNames.ADD_IMPORTWIZARD]: RouteNames.ADD_IMPORTWIZARD,
  [StateNames.CLONE_IMPORTWIZARD]: RouteNames.CLONE_IMPORTWIZARD,
  [StateNames.SUB_IMPORTWIZARD]: RouteNames.SUB_IMPORTWIZARD,
  [StateNames.LEADS]: RouteNames.LEADS,
  [StateNames.INTEGRATIONS]: RouteNames.INTEGRATIONS,
  [StateNames.INTEGRATIONS_MAPPINGS]: RouteNames.INTEGRATIONS_MAPPINGS,
  [StateNames.INTEGRATIONS_CONFIGURE]: RouteNames.INTEGRATIONS_CONFIGURE,
  [StateNames.INTEGRATIONS_FILE_INTEGRATION]: RouteNames.INTEGRATIONS_FILE_INTEGRATION,
  [StateNames.INTEGRATIONS_UPDATE_FILE_INTEGRATION]:
    RouteNames.INTEGRATIONS_UPDATE_FILE_INTEGRATION,
  [StateNames.INTEGRATIONS_SALESFORCE_INTEGRATION]: RouteNames.INTEGRATIONS_SALESFORCE_INTEGRATION,
  [StateNames.INTEGRATIONS_UPDATE_SALESFORCE_INTEGRATION]:
    RouteNames.INTEGRATIONS_UPDATE_SALESFORCE_INTEGRATION,
  [StateNames.INTEGRATIONS_WEBHOOK]: RouteNames.INTEGRATIONS_WEBHOOK,
  [StateNames.INTEGRATIONS_ACTIVITY_LOG]: RouteNames.INTEGRATIONS_ACTIVITY_LOG,
  [StateNames.INTEGRATIONS_ACTIVITY_RESULT_VIEW]: RouteNames.INTEGRATIONS_ACTIVITY_RESULT_VIEW,
};

export const FullFrameStates = [StateNames.REPORTSTUDIO_VIEW, StateNames.QUICKREPORT];

export const RightFrameStates = [
  StateNames.ADD_REPORTING_PROFILES,
  StateNames.EDIT_REPORTING_PROFILES,
  StateNames.REPORTING_PROFILES_DETAIL,
  StateNames.ADD_CATEGORIES_DETAIL,
  StateNames.EDIT_CATEGORIES_DETAIL,
  StateNames.CATEGORIES_DATAVIEWS,
  StateNames.CATEGORIES_METRIC,
  StateNames.MANAGE_SERVICES,
  StateNames.SERVICE_MAPPINGS,
  StateNames.MANAGE_LEADS,
  StateNames.DASHBOARD_VIEW,
  StateNames.BILLING,
  StateNames.BILLING_ADDRESS,
  StateNames.BILLING_CREDITCARD,
  StateNames.GOALS,
  StateNames.IMPORTWIZARD_DETAIL,
  StateNames.ADD_IMPORTWIZARD,
  StateNames.CLONE_IMPORTWIZARD,
  StateNames.SUB_IMPORTWIZARD,
  StateNames.LEADS,
  StateNames.MANAGE_SERVICES_OPEN,
  StateNames.INTEGRATIONS,
];

export const LegacyEvents = {
  UPDATE_DASHBOARD_NAV_ITEM: '$PageNuiEvents:UPDATE_DASHBOARD_NAV_ITEM',
  TRIGGER_GRANULAR_CONTROL_MODAL: '$PageNuiEvents:TriggerGranularControlModal',
  RELOAD_STATE: '$PageNuiEvents:ReloadState',
  VIEW_AUDIT_LOGS_FOR_WIDGET: '$PageNuiEvents.ViewAuditLogsForWidget',
  SHOW_NEW_EXPERIENCE_BANNER: '$PageNuiEvents.ShowNewExperienceBanner',
  ON_SWITCH_TO_NEW_EXPERIENCE_CLICKED:
    '$ExportBuilderDashboardUIEvents.ON_SWITCH_TO_NEW_EXPERIENCE_CLICKED',
};
